module.exports = __webpack_public_path__ + "img/00634453000501.d25fe53d.png";